import { Injectable, inject } from '@angular/core';
import { AnalyticsService, trackTimedApiCall } from '../../integrations/analytics';
import { ApiClient } from '../api-client.service';
import {
  toLocatorWireDestinationCode,
  type LocatorSearchRequest,
  type LocatorSearchResponse,
} from './models/locator.model';

/**
 * Locator API client for nearest service-location search.
 * Calls the live Locator Lambda only — failures propagate to callers (same pattern as
 * Product Master). Response fixtures for unit tests live under `testing/`.
 */
@Injectable({ providedIn: 'root' })
export class LocatorApiService {
  private readonly apiClient = inject(ApiClient);
  private readonly analytics = inject(AnalyticsService);

  /**
   * Searches for nearby service locations via `POST /locator/search`.
   * Strips spaces from `postalCode` and maps `INTL` → `INT` before sending.
   */
  async search(request: LocatorSearchRequest): Promise<LocatorSearchResponse> {
    const normalizedRequest = {
      ...request,
      postalCode: request.postalCode.replace(/\s+/g, ''),
      destinationCode: toLocatorWireDestinationCode(request.destinationCode),
    };

    return trackTimedApiCall(this.analytics, 'getDropoffLocation', () =>
      this.apiClient.post<LocatorSearchResponse>('/locator/search', normalizedRequest),
    );
  }
}
